import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { DialogService } from 'src/app/core/services/dialog.service';
import { FileService } from '../../../../core/services/file.service';
import { BaseDocumentationsComponent } from '../base/base-documentation.component';

@Component({
    selector: 'app-show-documents',
    templateUrl: './show-documents.component.html',
    styleUrls: ['./show-documents.component.scss'],
    standalone: false
})
export class ShowDocumentsComponent
  extends BaseDocumentationsComponent
  implements OnInit
{
  //#region properties
  @Input('selectedId') selectedId: any = 1;
  @Input('currentId') currentId: any = 2;
  // @Input('documents') documents: GetEnumValuesDto[];

  @Output('changeStatus') output_changeStatus = new EventEmitter<any>();

  //#endregion

  constructor(
    protected dialogService: DialogService,
    protected translate: TranslateService,
    protected fileService: FileService,
    protected domSanitizer: DomSanitizer
  ) {
    super(dialogService, translate, fileService, domSanitizer);
    this.formPageConfig.vocabs =
      'pages.organizations.organizationDocumentation.form.';
  }

  ngOnInit() {
    this.fields = this.formPageConfig.vocabs + 'fields.';
  }

  //change selected document`s status
  changeStatus(item) {
    this.output_changeStatus.emit(item);
  }
}
